import {
  WIDGET_LOGICAL_NAMES,
  METRIC_NAMES,
  TIMEFRAME_FILTER_TYPES,
  DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
  DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
  WIDGET_MODES,
  PRESETS,
  DASHBOARD_TAB_ID,
  MAP_WIDGET_INITIAL_HEIGHT,
} from '@config/Consts';

const defaultSettings = [
  {
    AMW_version_from: '1.0.0',
    AMW_version_to: '1.6.99',
    force_update_params: [],
    widget_settings:
      {
        global_filters: {
          agent_groups: [],
          timeframe: 1,
        },
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.2,
              h: 5.8,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.2,
              y: 0,
              w: 7.8,
              h: 5.8,
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                ],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 14,
              w: 12,
              h: 9.6,
              sort: [],
              filters: [],
            },
          },
        ],
      },
  },
  {
    AMW_version_from: '1.7.0',
    AMW_version_to: '1.7.99',
    force_update_params: ['widget_settings.settings[0].config.w', 'widget_settings.settings[1].config.x', 'widget_settings.settings[1].config.w'],
    widget_settings:
      {
        global_filters: {
          agent_groups: [],
          timeframe: 1,
        },
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.5,
              h: 5.8,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.5,
              y: 0,
              w: 7.5,
              h: 5.8,
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                ],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 14,
              w: 12,
              h: 9.6,
              sort: [],
              filters: [],
            },
          },
        ],
      },
  },
  {
    AMW_version_from: '1.8.0',
    AMW_version_to: '1.8.1',
    force_update_params: ['widget_settings.global_filters'],
    widget_settings:
      {
        global_filters: {
          groups: [],
          skills: [],
          timeframe: {
            type: TIMEFRAME_FILTER_TYPES.RELATIVE,
            relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
            absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
          },
        },
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.5,
              h: 5.8,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.5,
              y: 0,
              w: 7.5,
              h: 5.8,
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                ],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 14,
              w: 12,
              h: 9.6,
              sort: [],
              filters: [],
            },
          },
        ],
      },
  },
  {
    AMW_version_from: '1.8.2',
    AMW_version_to: '1.8.99',
    force_update_params: ['widget_settings.global_filters', 'widget_settings.settings[0].config.h', 'widget_settings.settings[1].config.h'],
    widget_settings:
      {
        global_filters: {
          groups: [],
          skills: [],
          timeframe: {
            type: TIMEFRAME_FILTER_TYPES.RELATIVE,
            relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
            absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
          },
        },
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.5,
              h: 9,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.5,
              y: 0,
              w: 7.5,
              h: 9,
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME,
                    show: true,
                  },
                ],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 14,
              w: 12,
              h: 9.6,
              sort: [],
              filters: [],
            },
          },
        ],
      },
  },
  {
    AMW_version_from: '1.9.0',
    AMW_version_to: '1.10.99',
    force_update_params: ['widget_settings.settings[1].config.h', 'widget_settings.settings[1].config.w', 'widget_settings.settings[1].config.x'],
    widget_settings:
      {
        global_filters: {
          groups: [],
          skills: [],
          timeframe: {
            type: TIMEFRAME_FILTER_TYPES.RELATIVE,
            relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
            absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
          },
        },
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.5,
              h: 9,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.5,
              y: 0,
              w: 7.5,
              h: 9,
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME,
                    show: true,
                  },
                ],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 14,
              w: 12,
              h: 9.6,
              sort: [],
              filters: [],
            },
          },
        ],
      },
  },
  {
    AMW_version_from: '1.11.0',
    AMW_version_to: '1.11.99',
    force_update_params: ['widget_settings.settings[2].config.y', 'widget_settings.settings[3].config.y'],
    widget_settings:
      {
        global_filters: {
          groups: [],
          skills: [],
          timeframe: {
            type: TIMEFRAME_FILTER_TYPES.RELATIVE,
            relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
            absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
          },
        },
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.5,
              h: 9,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.5,
              y: 0,
              w: 7.5,
              h: 9,
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME,
                    show: true,
                  },
                ],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 22,
              w: 12,
              h: 9.6,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SKILLS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SKILLS,
              x: 0,
              y: 14.2,
              w: 12,
              minH: 0.8,
              h: 9.6,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
        ],
      },
  },
  {
    AMW_version_from: '1.12.0',
    AMW_version_to: '1.12.99',
    force_update_params: ['widget_settings.settings[2].config.y', 'widget_settings.settings[3].config.y'],
    widget_settings:
      {
        preset: {
          currentPreset: {
            name: PRESETS.DEFAULT_PRESET_NAME,
          },
          presets: [
            {
              name: PRESETS.DEFAULT_PRESET_NAME,
              // Indicates whether to show the delete button for this preset
              // in the presets list
              isActionable: false,
              isSortable: false,
              isValid: true,
              widgets: {
                global: {
                  skills: [],
                  groups: [],
                  timeframe: {
                    type: TIMEFRAME_FILTER_TYPES.RELATIVE,
                    relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
                    absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
                  },
                },
              },
            },
          ],
        },
        global_filters: {
          groups: [],
          skills: [],
          timeframe: {
            type: TIMEFRAME_FILTER_TYPES.RELATIVE,
            relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
            absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
          },
        },
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.5,
              h: 9,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.5,
              y: 0,
              w: 7.5,
              h: 9,
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME,
                    show: true,
                  },
                ],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 22,
              w: 12,
              h: 9.6,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SKILLS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SKILLS,
              x: 0,
              y: 14.2,
              w: 12,
              minH: 0.8,
              h: 9.6,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.BOTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.BOTS,
              x: 0,
              y: 14.2,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
        ],
      },
  },
  {
    AMW_version_from: '1.13.0',
    AMW_version_to: '1.13.99',
    force_update_params: ['widget_settings.settings[2].config.y', 'widget_settings.settings[3].config.y', 'widget_settings.settings[4].config.y'],
    widget_settings:
      {
        preset: {
          currentPreset: {
            name: PRESETS.DEFAULT_PRESET_NAME,
          },
          presets: [
            {
              name: PRESETS.DEFAULT_PRESET_NAME,
              // Indicates whether to show the delete button for this preset
              // in the presets list
              isActionable: false,
              isSortable: false,
              isValid: true,
              widgets: {
                global: {
                  skills: [],
                  groups: [],
                  timeframe: {
                    type: TIMEFRAME_FILTER_TYPES.RELATIVE,
                    relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
                    absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
                  },
                },
              },
            },
          ],
        },
        global_filters: {
          groups: [],
          skills: [],
          timeframe: {
            type: TIMEFRAME_FILTER_TYPES.RELATIVE,
            relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
            absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
          },
        },
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.5,
              h: 9,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.5,
              y: 0,
              w: 7.5,
              h: 9,
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME,
                    show: true,
                  },
                ],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 32,
              w: 12,
              h: 9.6,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SKILLS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SKILLS,
              x: 0,
              y: 22.4,
              w: 12,
              minH: 0.8,
              h: 9.6,
              maxH: 32.3,
              sort: [],
              filters: [],
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.BOTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.BOTS,
              x: 0,
              y: 14.2,
              w: 12,
              minH: 0.8,
              h: 8.2,
              maxH: 32.3,
              sort: [],
              filters: [],
              widgetMode: WIDGET_MODES.CARDS,
              graphW: '400px',
            },
          },
        ],
      },
  },
  {
    AMW_version_from: '2.0.0',
    AMW_version_to: '2.1.99',
    force_update_params: [],
    widget_settings:
      {
        preset: {
          currentPreset: {
            name: PRESETS.DEFAULT_PRESET_NAME,
          },
          presets: [
            {
              name: PRESETS.DEFAULT_PRESET_NAME,
              // Indicates whether to show the delete button for this preset
              // in the presets list
              isActionable: false,
              isSortable: false,
              isValid: true,
              widgets: {
                global: {
                  skills: [],
                  groups: [],
                  timeframe: {
                    type: TIMEFRAME_FILTER_TYPES.RELATIVE,
                    relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
                    absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
                  },
                },
              },
            },
          ],
        },
        global_filters: {
          groups: [],
          skills: [],
          timeframe: {
            type: TIMEFRAME_FILTER_TYPES.RELATIVE,
            relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
            absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
          },
        },
        selectedTabId: DASHBOARD_TAB_ID,
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.5,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.IN_QUEUE],
              sort: [],
              filters: [],
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.IN_QUEUE],
              isCollapsed: false,
              originalSize: {
                x: 0,
                y: 0,
                w: 4.5,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.IN_QUEUE],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.5,
              y: 0,
              w: 7.5,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SHIFT_STATUS],
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME,
                    show: true,
                  },
                ],
              },
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SHIFT_STATUS],
              isCollapsed: false,
              originalSize: {
                x: 4.5,
                y: 0,
                w: 7.5,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SHIFT_STATUS],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.AGENTS],
              maxH: 32.3,
              sort: [],
              filters: [],
              isCollapsed: false,
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.AGENTS],
              originalSize: {
                x: 0,
                y: 6,
                w: 12,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.AGENTS],
              },
              widgetMode: WIDGET_MODES.TABLE,
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 32,
              w: 12,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.CONVERSATIONS],
              sort: [],
              filters: [],
              isCollapsed: false,
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.CONVERSATIONS],
              originalSize: {
                x: 0,
                y: 32,
                w: 12,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.CONVERSATIONS],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SKILLS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SKILLS,
              x: 0,
              y: 22.4,
              w: 12,
              minH: 0.8,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SKILLS],
              maxH: 32.3,
              sort: [],
              filters: [],
              isCollapsed: false,
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SKILLS],
              originalSize: {
                x: 0,
                y: 22.4,
                w: 12,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SKILLS],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.BOTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.BOTS,
              x: 0,
              y: 14.2,
              w: 12,
              minH: 0.8,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.BOTS],
              maxH: 32.3,
              sort: [],
              filters: [],
              widgetMode: WIDGET_MODES.TABLE,
              graphW: '400px',
              isCollapsed: false,
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.BOTS],
              originalSize: {
                x: 0,
                y: 14.2,
                w: 12,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.BOTS],
              },
            },
          },
        ],
      },
  },
  {
    AMW_version_from: '2.2.0',
    AMW_version_to: '3.0.0',
    force_update_params: [
      'widget_settings.settings[0].config.h',
      'widget_settings.settings[1].config.h',
      'widget_settings.settings[0].config.expandedH',
      'widget_settings.settings[1].config.expandedH',
      'widget_settings.settings[0].config.originalSize.h',
      'widget_settings.settings[1].config.originalSize.h',
    ],
    widget_settings:
      {
        preset: {
          currentPreset: {
            name: PRESETS.DEFAULT_PRESET_NAME,
          },
          presets: [
            {
              name: PRESETS.DEFAULT_PRESET_NAME,
              // Indicates whether to show the delete button for this preset
              // in the presets list
              isActionable: false,
              isSortable: false,
              isValid: true,
              widgets: {
                global: {
                  skills: [],
                  groups: [],
                  timeframe: {
                    type: TIMEFRAME_FILTER_TYPES.RELATIVE,
                    relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
                    absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
                  },
                },
              },
            },
          ],
        },
        global_filters: {
          groups: [],
          skills: [],
          timeframe: {
            type: TIMEFRAME_FILTER_TYPES.RELATIVE,
            relativeHour: DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
            absoluteHour: DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
          },
        },
        selectedTabId: DASHBOARD_TAB_ID,
        settings: [
          {
            name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.IN_QUEUE,
              x: 0,
              y: 0,
              w: 4.5,
              h: 11.5,
              // h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.IN_QUEUE],
              sort: [],
              filters: [],
              expandedH: 11.5,
              // expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.IN_QUEUE],
              isCollapsed: false,
              originalSize: {
                x: 0,
                y: 0,
                w: 4.5,
                h: 11.5,
                // h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.IN_QUEUE],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
              x: 4.5,
              y: 0,
              w: 7.5,
              h: 11.5,
              // h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SHIFT_STATUS],
              custom: {
                metrics: [
                  {
                    logicalName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CLOSED_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.LOAD_CONVERSATIONS,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.CSAT,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_WAIT_TIME,
                    show: true,
                  },
                  {
                    logicalName: METRIC_NAMES.AVG_CONVERSATIONS_DURATION,
                    show: true,
                  },
                ],
              },
              expandedH: 11.5,
              // expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SHIFT_STATUS],
              isCollapsed: false,
              originalSize: {
                x: 4.5,
                y: 0,
                w: 7.5,
                h: 11.5,
                // h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SHIFT_STATUS],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.AGENTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.AGENTS,
              x: 0,
              y: 6,
              w: 12,
              minH: 0.8,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.AGENTS],
              maxH: 32.3,
              sort: [],
              filters: [],
              isCollapsed: false,
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.AGENTS],
              originalSize: {
                x: 0,
                y: 6,
                w: 12,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.AGENTS],
              },
              widgetMode: WIDGET_MODES.TABLE,
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
            config: {
              show: true,
              resizable: false,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
              x: 0,
              y: 32,
              w: 12,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.CONVERSATIONS],
              sort: [],
              filters: [],
              isCollapsed: false,
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.CONVERSATIONS],
              originalSize: {
                x: 0,
                y: 32,
                w: 12,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.CONVERSATIONS],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.SKILLS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.SKILLS,
              x: 0,
              y: 22.4,
              w: 12,
              minH: 0.8,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SKILLS],
              maxH: 32.3,
              sort: [],
              filters: [],
              isCollapsed: false,
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SKILLS],
              originalSize: {
                x: 0,
                y: 22.4,
                w: 12,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.SKILLS],
              },
            },
          },
          {
            name: WIDGET_LOGICAL_NAMES.BOTS,
            config: {
              show: true,
              resizable: true,
              authorized: false,
              i: WIDGET_LOGICAL_NAMES.BOTS,
              x: 0,
              y: 14.2,
              w: 12,
              minH: 0.8,
              h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.BOTS],
              maxH: 32.3,
              sort: [],
              filters: [],
              widgetMode: WIDGET_MODES.TABLE,
              graphW: '400px',
              isCollapsed: false,
              expandedH: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.BOTS],
              originalSize: {
                x: 0,
                y: 14.2,
                w: 12,
                h: MAP_WIDGET_INITIAL_HEIGHT[WIDGET_LOGICAL_NAMES.BOTS],
              },
            },
          },
        ],
      },
  },
];

export {
  defaultSettings,
};
